import AgentNode from "../components/designer/AgentNode";
import AssetNode from "../components/designer/AssetNode";
import McpServerNode from "../components/designer/McpServerNode";
import ServiceNode from "../components/designer/ServiceNode";

export const designerNodes = {
  dataset: AssetNode,
  model: AssetNode,
  // ----- TODO REMOVE REDUNTANT NODES -----
  batch: ServiceNode,
  stream: ServiceNode,
  // ---------------------------------------
  service: ServiceNode,
  agent: AgentNode,
  mcp: McpServerNode,
};
export type NodeType = keyof typeof designerNodes;

export type PaletteNode = {
  id?: number;
  name: string;
  type: NodeType;
  tooltipContent: React.ReactNode;
  meta: { [key: string]: any };
}